<template>
  <section>
    <v-dialog v-model="repetidosModal" scrollable persistent max-width="700">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title><h4>Validación de Firma Digital</h4></v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="cancel()">
              <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar> 
        <v-card-text>
                  <v-layout>
                    <v-flex md12 sm12> 
                      <br>
                      <h4 class="black--text">Verifique la autenticidad de su documento firmado digitalmente por la Contraloría General del Estado.</h4>
                    </v-flex>
                  </v-layout>                          
                  <v-layout align-center justify-center row wrap>
                    <v-flex md8 sm8>
                      <v-btn
                        :loading="loadingUpload"
                        color="primary"
                        class="ma-2 white--text"
                        large
                        block
                        @click="fileClick1"
                        v-model="fileName1"
                      >
                        <v-icon>cloud_upload</v-icon>&nbsp;Seleccionar PDF
                        <template v-slot:loader>
                     <span>procesando..</span>
                     </template>
                      </v-btn>
                      <input
                        type="file"
                        style="display: none"
                        ref="filePdf1"
                        accept="application/pdf"
                        @change="onFilePdf1"
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>   
                <v-card-actions>
           <v-spacer></v-spacer>
            <v-btn color="error" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>          
          </v-card-actions>         
              </v-card>
        </v-dialog>
          <v-dialog v-model="dialog" scrollable max-width="1100px">
            <v-card>
              <v-toolbar dark color="primary">
                <v-toolbar-title><h4>Información del Documento</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialog = false, limpiar()">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <div style="padding: 15px;">
                <h4>DATOS DE LA VALIDACIÓN DE FIRMA DIGITAL DEL CERTIFICADO</h4>
                <p v-if="this.tipoMensaje === 'warning'"><v-icon color="red">block</v-icon><b> El certificado no es válido,</b> debido a que el documento ha sido modificado o cuenta con una firma no autorizada.</p>
                <div v-if="this.tipoMensaje === 'success'">
                  <div v-for="item in firmanteEntidad" v-bind:key="item.id">
                    <p><v-icon color="green">check_circle</v-icon> El certificado es válido y fue firmado digitalmente por <strong>{{item.signatario}}</strong></p>
                  </div>
                </div>
                <p>NOTA.- Para verificar la veracidad de un certificado digital el QR le redireccionará al Sistema de Declaraciones Juradas de Bienes y Rentas de la CGE.</p>
              </div>
              <v-divider></v-divider>
                <v-card-text style="height: 1100px;">
                  <pdf-view
                    v-if="this.dataPdfBase64"
                    :data="dataPdfBase64"
                    :storage="2"
                    :url="url"
                  ></pdf-view>
                  <v-divider></v-divider>
              <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="error" text @click="dialog = false, limpiar()"><v-icon>cancel</v-icon>&nbsp;cerrar</v-btn>
              </v-card-actions>
                </v-card-text>
            </v-card>
          </v-dialog>
        <div class="centered">
      <v-layout wrap>
        <v-flex md12>
               <v-btn small flat color="primary" @click.stop='repetidosModal = true'>
                     <p style="color:white;"><v-icon>card_membership</v-icon><b>&nbsp;Validación de firma digital</b></p>
                  </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </section>
</template>
<script>
import Captcha from './mixins/captcha.js';
import PdfView from '@/common/util/PdfView.vue';
export default {
  components: {
    PdfView
  },
  mixins: [ Captcha ],
  created () {
    const req = this.$route.query.dmFsaWRhY2lvbmNlcnRpZmljYWRv;
    if (req) {
      const buff = Buffer.from(req, 'base64');
      const text = buff.toString('ascii');
      if (text.search(':') > 0) {
        const [codigoControl, dateFormatted] = text.split(':');
        this.dateFormatted = dateFormatted;
        this.codigoControl = codigoControl;
        this.buscar();
      }
    }
  },
  data: () => ({
    normalModal: false,
    repetidosModal: false,
    dialog: false,
    loader: null,
    loadingUpload: false,
    url: 'http://localhost/api/download/pdf',
    menu: false,
    date: new Date().toISOString().substr(0, 10),
    dRules: [v => !!v || 'Este campo es requerido'],
    validacion: false,
    pdfFile: '',
    fileName1: '',
    fileBase64: '',
    dataPdfBase64: '',
    dateFormatted: null,
    codigoControl: '',
    firmanteEntidad: [],
    tipoMensaje: '',
    respuesta: {
      tipdoc: '',
      docidentidad: '',
      expedicion: '',
      apellidos: '',
      nombres: '',
      motivoDeclaracion: '',
      fechaRecepcion: '',
      fechaUltimaVisita: '',
      entidad: '',
      cargo: '',
      numeroCertificadoDep: '',
      numeroCertificadoNac: '',
      codigoControlCge: ''
    },
    form: {
      cueperdec_login: 'aaa01011975q',
      cueperdec_contrasenia: '123456*a',
      responseCaptcha: ''
    },
    imgb64: '',
    textCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA,
    valid: false,
    entidad: []
  }),
  methods: {
    fileClick1 () {
      this.$refs.filePdf1.click();
    },
    onFilePdf1 (e) {
      this.firmanteEntidad = [];
      this.loadingUpload = true;
      const files = e.target.files;
      if (files[0].size < 2097152) {
        if (files[0] !== undefined) {
          this.fileName1 = files[0].name;
          if (this.fileName1.lastIndexOf('.') <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener('load', () => {
            this.fileBase64 = fr.result;
            this.pdfFile = files[0];
            this.$storage.set('token', process.env.TOKEN_EXTERNO);
            this.$service.post(`system/validar`, {file: this.fileBase64}).then(response => {
              this.$storage.remove('token');
              if (response) {
                this.loadingUpload = false;
                this.tipoMensaje = response.verificacion && response.certificado.length > 0 ? 'success' : 'warning';
                this.tipoMensaje = response.certificado.length === 0 ? 'error' : this.tipoMensaje;
                this.$message[this.tipoMensaje]('Validación  : ' + response.message);
                if (this.tipoMensaje !== 'error') {
                  this.dataPdfBase64 = this.fileBase64.replace('data:application/pdf;base64,', '');
                  this.entidad = response.certificado;
                  const certs = response.certificado;
                  let firmanteEntidadArr = [];
                  let firmanteEntidadData = {};
                  let i = 0;
                  certs.forEach(function (cert) {
                    firmanteEntidadData = { id: i, signatario: cert.nombreComunSubject, entidad: '' };
                    firmanteEntidadData = cert.organizacionSubject ? { id: i, signatario: cert.nombreComunSubject, entidad: cert.organizacionSubject } : firmanteEntidadData;
                    firmanteEntidadArr.push(firmanteEntidadData);
                    i = i + 1;
                  });
                  this.dialog = true;
                  this.validacion = false;
                  this.firmanteEntidad = firmanteEntidadArr;
                }
              } else {
                this.$message['warning']('No es posible realizar la validación');
                this.loadingUpload = false;
              }
            }).catch(error => {
              console.error(error);
              this.$storage.remove('token');
            });
          });
        } else {
          this.fileName1 = '';
          this.pdfFile1 = '';
          this.fileUrl1 = '';
          this.loadingUpload = false;
          this.$storage.remove('token');
        }
      } else {
        this.$message['warning']('El documento no puede exceder de los 2MB');
        this.fileName1 = '';
        this.pdfFile1 = '';
        this.fileUrl1 = '';
        this.loadingUpload = false;
        this.$storage.remove('token');
      }
      this.$storage.remove('token');
    },
    limpiar () {
      this.pdfFile = '';
      this.fileName1 = '';
      this.fileBase64 = '';
      this.dataPdfBase64 = '';
      this.firmanteEntidad = [];
      this.tipoMensaje = '';
      this.validacion = false;
    },
    limpiar2 () {
      this.respuesta = [];
      this.normalModal = false;
    },
    cancel () {
      this.repetidosModal = false;
      this.loadingUpload = false;
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date);
    },
    computedDateFormattedF () {
      return this.formatDateF(this.dateF);
    }
  },
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
    date (val) {
      this.dateFormatted = this.formatDate(this.date);
    }
  }
};
</script>

<style lang='scss'>
.pdf-view .pdf-view-actions .pdf-view-buttons .visible {
  visibility: hidden !important;
}
.subtitulo {
  color: #1976D2;
  text-transform: uppercase;
}
.espacio {
  width: 10px;
  height: 100px;
  border:white 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/portal/comprobacionFir.vue